<button type="button" class="btn btn-dot" id="glo-navigation-back-button" title="Button">
  <svg width="20" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M9.406 1.34L1.746 9l7.66 7.66M18.75 9H1.746" stroke="#06F" stroke-width="2" fill="none" fill-rule="evenodd" stroke-linecap="round" /></svg>
</button>
